/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener("DOMContentLoaded", function() {
  
  document.querySelectorAll('.quick-links').forEach(function(quickLinks) {
    var savedPosition = sessionStorage.getItem('scrollPosition');
    
    // Check if scrolling is possible
    var canScroll = quickLinks.scrollWidth > quickLinks.clientWidth;
    
    // Save new scroll position on scroll
    quickLinks.addEventListener('scroll', function() {
      sessionStorage.setItem('scrollPosition', quickLinks.scrollLeft);
    });

    // Function to check if an element is in view
    function isInView(container, element) {
      const containerLeft = container.scrollLeft;
      const containerRight = containerLeft + container.clientWidth;
      const elementLeft = element.offsetLeft;
      const elementRight = elementLeft + element.clientWidth;
      
      return elementLeft >= containerLeft && elementRight <= containerRight;
    }

    // Get the active link
    const activeLink = quickLinks.querySelector('.quick-links-item.is-active');

    // If there's a saved position and scrolling is possible
    if(savedPosition && canScroll) {
      quickLinks.scrollLeft = savedPosition;

      // If the active link is not in view after scrolling to saved position
      if(activeLink && !isInView(quickLinks, activeLink)) {
        // Calculate the position to center the active link
        let centerPosition = activeLink.offsetLeft + (activeLink.clientWidth / 2) - (quickLinks.clientWidth / 2);
        
        // Adjust for beginning and end of the list
        centerPosition = Math.max(centerPosition, 0);
        centerPosition = Math.min(centerPosition, quickLinks.scrollWidth - quickLinks.clientWidth);
        
        quickLinks.scrollLeft = centerPosition;
      }
    } else if (activeLink && canScroll) {
      // If there's no saved position but there's an active link
      let centerPosition = activeLink.offsetLeft + (activeLink.clientWidth / 2) - (quickLinks.clientWidth / 2);
      
      // Adjust for beginning and end of the list
      centerPosition = Math.max(centerPosition, 0);
      centerPosition = Math.min(centerPosition, quickLinks.scrollWidth - quickLinks.clientWidth);
      
      quickLinks.scrollLeft = centerPosition;
    }
  });
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// navigate-next.js
const boundNavigateNextButtons = new WeakSet();

function navigateToNextSection(event) {
  event.preventDefault();

  const nextSection = event.currentTarget.closest('.shopify-section')?.nextElementSibling;
  if (!nextSection) return;

  const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
  const targetPosition = nextSection.getBoundingClientRect().top + window.pageYOffset - headerHeight + 20;

  window.scrollTo({
    top: targetPosition,
    behavior: window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto'
  });
}

function bindNavigateNextButtons(root = document) {
  const buttons = [
    ...(root.matches?.('[data-action="navigate-next"]') ? [root] : []),
    ...Array.from(root.querySelectorAll?.('[data-action="navigate-next"]') || [])
  ];

  buttons.forEach((button) => {
    if (boundNavigateNextButtons.has(button)) return;
    boundNavigateNextButtons.add(button);
    button.addEventListener('click', navigateToNextSection);
  });
}

bindNavigateNextButtons();
document.addEventListener('shopify:section:load', (event) => bindNavigateNextButtons(event.target));

/**
 * Native Klaviyo Back in Stock form.
 *
 * The theme's x-modal component provides a side drawer on desktop and a bottom
 * sheet on mobile. Klaviyo's client endpoint only needs the shopper email and
 * the selected Shopify variant ID, so no private API key is exposed here.
 */
const BACK_IN_STOCK_REQUEST_TIMEOUT = 15000;

class BackInStock extends HTMLElement {
  connectedCallback() {
    if (this.abortController && !this.abortController.signal.aborted) return;

    this.initialized = true;
    this.abortController = new AbortController();
    this.boundTriggers = new WeakSet();
    this.submissionRevision ||= 0;
    this.productForm = document.forms[this.dataset.productForm];
    this.modal = this.querySelector('x-modal');
    if (this.modal) this.modal.backInStockComponent = this;
    this.form = this.querySelector('[data-back-in-stock-form]');
    this.emailInput = this.form?.querySelector('input[type="email"]');
    this.message = this.querySelector('[data-back-in-stock-message]');
    this.messageText = this.querySelector('[data-back-in-stock-message-text]');
    this.successIcon = this.querySelector('[data-back-in-stock-success-icon]');
    this.fallbackLink = this.querySelector('[data-back-in-stock-fallback]');
    this.fallbackMessage = this.querySelector('[data-back-in-stock-fallback-message]');
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    this.productName = this.querySelector('[data-back-in-stock-product]');
    this.variantName = this.querySelector('[data-back-in-stock-variant]');
    this.variantImage = this.querySelector('[data-back-in-stock-image]');
    this.variant = this.getVariant(this.dataset.initialVariantId) || {
      id: this.dataset.initialVariantId,
      available: this.dataset.initialVariantAvailable === 'true'
    };

    if (!this.productForm || !this.modal || !this.form || !this.emailInput || !this.submitButton) return;

    // The theme event is the normal integration point. The ID-input change
    // listener is a fallback that updates immediately even when app code
    // changes the selector without forwarding the custom event.
    this.productForm.addEventListener('variant:change', (event) => {
      this.updateVariant(event.detail?.variant || this.getVariantFromForm());
    }, { signal: this.abortController.signal });
    this.productForm.addEventListener('change', (event) => {
      if (event.target.name === 'id') this.updateVariantById(event.target.value);
    }, { signal: this.abortController.signal });
    this.productForm.addEventListener('product:rerender', (event) => {
      if (event.detail?.productChange) this.retireDetachedModal();
    }, { capture: true, signal: this.abortController.signal });
    this.bindTriggers();
    this.form.addEventListener('submit', (event) => this.submit(event), { signal: this.abortController.signal });
    // Clear the email and feedback when the sheet closes so a later variant
    // selection always starts with a clean form.
    this.modal.addEventListener('dialog:after-show', () => window.JomoAnalytics?.waitlistOpened(this), { signal: this.abortController.signal });
    this.modal.addEventListener('dialog:after-hide', () => {
      this.waitlistOpenTracked = false;
      this.resetForm();
    }, { signal: this.abortController.signal });
    this.updateVariant(this.variant);
  }

  disconnectedCallback() {
    this.submissionRevision += 1;
    this.abortController?.abort();
    this.submissionController?.abort();
    this.submissionController = null;
    this.retireDetachedModal();
  }

  // Triggers live outside this element (the sticky bar renders after it, and a section re-render replaces the nodes),
  // so they are resolved on every update rather than captured once at connect time.
  get triggers() {
    return Array.from(document.querySelectorAll('[data-back-in-stock-trigger]')).filter(
      (trigger) => trigger.getAttribute('aria-controls') === this.modal?.id
    );
  }

  get addToCartButtons() {
    return Array.from(document.querySelectorAll(`buy-buttons[form="${this.dataset.productForm}"] button[type="submit"]`));
  }

  bindTriggers() {
    const triggers = this.triggers;

    triggers.forEach((trigger) => {
      if (this.boundTriggers.has(trigger)) return;
      this.boundTriggers.add(trigger);

      // x-modal also has delegated aria-controls handling. This direct listener runs in the target phase, ahead of
      // that delegate, so stopping propagation here keeps the modal from being toggled straight back closed.
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.modal.show();
      }, { signal: this.abortController.signal });
    });

    return triggers;
  }

  updateVariant(variant) {
    const changedVariant = this.variant?.id !== variant?.id;
    this.variant = variant || null;

    const triggers = this.bindTriggers();
    const isSoldOut = Boolean(this.variant && !this.variant.available);

    triggers.forEach((trigger) => {
      trigger.hidden = !isSoldOut;
      trigger.disabled = !isSoldOut;
    });

    // Only ever hide add-to-cart when there is a waitlist trigger to take its place, otherwise a sold-out variant
    // would leave the shopper with no control at all.
    if (triggers.length) {
      this.addToCartButtons.forEach((button) => {
        button.hidden = isSoldOut;
      });
    }

    if (this.productName) {
      this.productName.textContent = this.dataset.productTitle;
    }

    if (this.variantName) {
      const hasVariantTitle = this.variant?.title && this.variant.title !== 'Default Title';
      this.variantName.textContent = hasVariantTitle ? this.variant.title : '';
      this.variantName.hidden = !hasVariantTitle;
    }

    if (this.variantImage) {
      const imageUrl = this.variant?.featured_image?.src || this.variant?.featured_media?.preview_image?.src || this.dataset.defaultImage;
      if (imageUrl) {
        this.variantImage.src = imageUrl;
        this.variantImage.hidden = false;
        this.variantImage.alt = this.variant?.title && this.variant.title !== 'Default Title' ? `${this.dataset.productTitle} — ${this.variant.title}` : this.dataset.productTitle;
      } else {
        this.variantImage.hidden = true;
      }
    }

    if (changedVariant) this.resetForm();
    if (!isSoldOut && this.modal.open) this.modal.hide();
  }

  getVariantFromScript(script) {
    try {
      return JSON.parse(script?.textContent || 'null');
    } catch (error) {
      return null;
    }
  }

  getVariant(id) {
    const pickerSelector = `variant-picker[form-id="${CSS.escape(this.dataset.productForm)}"] script[data-variant]`;
    const scope = this.closest('product-rerender') || document;
    const pickerVariant = this.getVariantFromScript(scope.querySelector(pickerSelector) || document.querySelector(pickerSelector));
    const initialVariant = this.getVariantFromScript(this.querySelector('[data-back-in-stock-current-variant]'));

    if (pickerVariant?.id && (!id || String(pickerVariant.id) === String(id))) return pickerVariant;
    if (initialVariant?.id && (!id || String(initialVariant.id) === String(id))) return initialVariant;
    return null;
  }

  getVariantFromForm() {
    return this.getVariant(this.productForm?.querySelector('[name="id"]')?.value);
  }

  updateVariantById(id) {
    const variant = this.getVariant(id);

    // Prestige updates the hidden ID before it swaps the server-rendered variant-picker script. During that small
    // interval the new ID cannot be resolved without serializing the full product variant array. Keep the last
    // confirmed state until `variant:change` supplies the authoritative object instead of flashing the wrong controls
    // or closing a sold-out modal during a sold-out-to-sold-out selection.
    if (variant) this.updateVariant(variant);
  }

  retireDetachedModal() {
    if (!this.modal || this.modal.parentElement !== document.body) return;

    // Prestige temporarily moves open modals to <body>. Rename the outgoing node immediately so a full product
    // re-render cannot create duplicate IDs, then let the dialog close normally to release its focus/scroll lock.
    if (!this.modal.dataset.retiring) {
      this.triggers.forEach((trigger) => {
        trigger.hidden = true;
        trigger.disabled = true;
        trigger.setAttribute('aria-expanded', 'false');
      });
      this.modal.dataset.retiring = 'true';
      this.modal.id = `${this.modal.id}-retiring`;
      this.modal.addEventListener('dialog:after-hide', () => this.modal.remove(), { once: true });
    }

    if (this.modal.open) {
      this.modal.hide();
    } else {
      this.modal.remove();
    }
  }

  async submit(event) {
    event.preventDefault();
    if (this.submissionController) return;

    this.clearMessage();
    this.updateVariant(this.getVariantFromForm());

    if (!this.variant?.id) {
      this.setMessage(this.dataset.selectOptionMessage, 'error');
      return;
    }

    if (!this.emailInput.checkValidity()) {
      this.emailInput.reportValidity();
      return;
    }

    const submittedVariant = this.variant;
    const submissionRevision = ++this.submissionRevision;
    this.submissionController?.abort();
    const submissionController = new AbortController();
    this.submissionController = submissionController;
    const submissionTimeout = setTimeout(() => submissionController.abort(), BACK_IN_STOCK_REQUEST_TIMEOUT);
    this.submitButton.disabled = true;
    this.submitButton.setAttribute('aria-busy', 'true');

    let response;

    try {
      try {
        response = await fetch(this.dataset.endpoint, {
          method: 'POST',
          // text/plain keeps this a CORS "simple request", so the browser skips the OPTIONS preflight entirely.
          // The proxy builds the Klaviyo JSON:API envelope and holds the credential.
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify({ email: this.emailInput.value.trim(), variantId: submittedVariant.id }),
          signal: submissionController.signal
        });
      } catch (error) {
        if (submissionRevision !== this.submissionRevision) return;

        console.warn('[Back in stock] Request to the waitlist proxy never completed', error);
        this.setMessage(this.dataset.networkErrorMessage, 'error', true);
        this.submitButton.disabled = false;
        return;
      }

      try {
        if (submissionRevision !== this.submissionRevision) return;

        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          if (submissionRevision !== this.submissionRevision) return;
          throw new Error(body.error || `Waitlist proxy responded with ${response.status}`);
        }

        this.trackSubscription(submittedVariant);
        this.setMessage(this.dataset.successMessage);
        this.emailInput.disabled = true;
        this.submitButton.disabled = true;
        this.submitButton.hidden = true;
      } catch (error) {
        // The proxy's error code is useful in the console but is not shopper-facing copy.
        console.warn('[Back in stock]', error);
        this.setMessage(this.dataset.errorMessage, 'error', true);
        this.submitButton.disabled = false;
      }
    } finally {
      clearTimeout(submissionTimeout);
      if (submissionRevision === this.submissionRevision) {
        this.submissionController = null;
        this.submitButton.removeAttribute('aria-busy');
      }
    }
  }

  trackSubscription(variant = this.variant) {
    const variantTitle = variant?.title && variant.title !== 'Default Title'
      ? variant.title
      : 'Default';
    const eventData = {
      product_id: String(this.dataset.productId || variant?.product_id || ''),
      product_handle: this.dataset.productHandle || '',
      product_name: this.dataset.productTitle || '',
      variant_id: String(variant?.id || ''),
      variant_name: variantTitle
    };

    try {
      const shopifyPublish = window.Shopify?.analytics?.publish?.('jomo:back_in_stock_subscribed', eventData);
      shopifyPublish?.catch?.((error) => console.warn('[Back in stock analytics]', error));
    } catch (error) {
      console.warn('[Back in stock analytics]', error);
    }

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'back_in_stock_subscribed', eventData);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'back_in_stock_subscribed', ...eventData });
      }
    } catch (error) {
      console.warn('[Back in stock analytics]', error);
    }
  }

  resetForm() {
    this.submissionRevision += 1;
    this.submissionController?.abort();
    this.submissionController = null;
    if (this.emailInput) {
      this.emailInput.value = '';
      this.emailInput.disabled = false;
    }
    if (this.submitButton) {
      this.submitButton.disabled = false;
      this.submitButton.hidden = false;
      this.submitButton.removeAttribute('aria-busy');
    }
    this.clearMessage();
  }

  buildFallbackHref() {
    const email = this.dataset.contactEmail;
    if (!email) return null;

    const variantTitle = this.variant?.title && this.variant.title !== 'Default Title' ? ` — ${this.variant.title}` : '';
    const product = `${this.dataset.productTitle}${variantTitle}`;
    const subject = `Waitlist request: ${product}`;
    const body = [
      `Please add me to the waitlist for ${product}.`,
      '',
      `Email: ${this.emailInput?.value.trim() || ''}`,
      `Product: ${window.location.href}`
    ].join('\n');

    return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  setMessage(message, status = 'success', showFallback = false) {
    this.messageText.textContent = message;
    this.message.hidden = false;
    this.message.classList.toggle('banner--success', status === 'success');
    this.message.classList.toggle('banner--error', status === 'error');
    this.successIcon.hidden = status !== 'success';

    if (this.fallbackLink) {
      const href = showFallback ? this.buildFallbackHref() : null;
      if (href) this.fallbackLink.href = href;
      this.fallbackLink.hidden = !href;
      if (this.fallbackMessage) this.fallbackMessage.hidden = !href;
    }
  }

  clearMessage() {
    if (!this.message) return;
    this.messageText.textContent = '';
    this.message.hidden = true;
    this.message.classList.remove('banner--success', 'banner--error');
    this.successIcon.hidden = true;
    if (this.fallbackLink) this.fallbackLink.hidden = true;
    if (this.fallbackMessage) this.fallbackMessage.hidden = true;
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock);
}

// Keep the waitlist UI in sync even if a product form is reconnected or an
// app listens to and alters the theme event first. Variant events bubble from
// the product form, so this catches every product-page selection centrally.
function syncBackInStockForForm(form, variant) {
  if (!form?.id) return;

  document.querySelectorAll('back-in-stock').forEach((component) => {
    if (component.initialized && component.dataset.productForm === form.id) {
      component.updateVariant(variant || component.getVariantFromForm());
    }
  });
}

document.addEventListener('variant:change', (event) => {
  syncBackInStockForForm(event.target, event.detail?.variant);
});

document.addEventListener('change', (event) => {
  if (event.target.name === 'id') {
    syncBackInStockForForm(event.target.form);
  }
});
